
(function () {
    'use strict';

    angular.module('filters.monsido').filter('frequencyTranslation', frequencyTranslationController);

    frequencyTranslationController.$inject = ['FrequencyTranslationService'];
    /* @ngInject */
    function frequencyTranslationController (FrequencyTranslationService) {
        return frequencyTranslation;

        // //////////

        function frequencyTranslation (frequency) {
            return FrequencyTranslationService.getFrequencyTranslation(frequency);
        }
    }
})();
